/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBazzarvoiceWidgetViewProps } from './bazzarvoice-widget';
import Bazzarvoice from './components/Bazzarvoice';

export default (props: IBazzarvoiceWidgetViewProps) => {
    const {
        data: { product },
        config
    } = props;

    const newProductSku = product.result?.ExtensionProperties?.find(ep => ep.Key === 'NewSku')?.Value?.StringValue?.split(':')[1];
    const itemId = newProductSku ?? product?.result?.ItemId;

    return <Bazzarvoice itemId={itemId} widgetType={config.widgetType} />;
};
